import { render } from "./ScrollTrigger.vue?vue&type=template&id=3cad2ec0"
import script from "./ScrollTrigger.vue?vue&type=script&lang=js"
export * from "./ScrollTrigger.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__